/**
 * Marca de Dentu: un molar con un destello.
 * El destello = "diente limpio", y da un punto de color que hace que el logo se
 * lea a 20px (en la barra lateral) igual que a 120px (en el login).
 *
 * Uso:
 *   <BrandMark className="h-9 w-9" />           → el símbolo solo
 *   <BrandLockup />                             → símbolo + "Dentu" + bajada
 */

const TOOTH_PATH =
  'M12 3.2c-1.8 0-2.5.85-3.7.85-1.15 0-2.5-.85-3.45.4C3.7 6.2 4.05 9 4.6 11.2c.66 2.6 1.15 6.3 2.9 6.3 1.45 0 1.35-3.6 2.6-3.6s1.15 3.6 2.6 3.6c1.75 0 2.24-3.7 2.9-6.3.55-2.2.9-5-.25-6.75-.95-1.25-2.3-.4-3.45-.4-1.2 0-1.9-.85-3.7-.85z';

const SPARK_PATH =
  'M17.6 2.1c.16-.42.76-.42.92 0l.55 1.53c.05.13.15.23.28.28l1.53.55c.42.16.42.76 0 .92l-1.53.55a.45.45 0 0 0-.28.28l-.55 1.53c-.16.42-.76.42-.92 0l-.55-1.53a.45.45 0 0 0-.28-.28l-1.53-.55c-.42-.16-.42-.76 0-.92l1.53-.55a.45.45 0 0 0 .28-.28l.55-1.53z';

export const BrandMark = ({ className = 'h-9 w-9', showSpark = true }) => (
  <svg viewBox="0 0 24 24" className={className} role="img" aria-label="Dentu">
    <defs>
      <linearGradient id="dentu-brand-gradient" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="hsl(var(--brand-from))" />
        <stop offset="100%" stopColor="hsl(var(--brand-to))" />
      </linearGradient>
    </defs>
    <path d={TOOTH_PATH} fill="url(#dentu-brand-gradient)" />
    {showSpark && (
      <path d={SPARK_PATH} fill="hsl(var(--brand-from))" className="drop-shadow-sm" />
    )}
  </svg>
);

/** Cuadro de marca con degradado + símbolo en blanco (sidebar, login, favicon). */
export const BrandTile = ({ className = 'h-10 w-10', iconClass = 'h-5 w-5' }) => (
  <div
    className={`${className} relative grid place-items-center rounded-xl bg-brand-gradient shadow-[var(--shadow-glow)]`}
  >
    <svg viewBox="0 0 24 24" className={iconClass} aria-hidden="true">
      <path d={TOOTH_PATH} fill="white" fillOpacity="0.96" />
      <path d={SPARK_PATH} fill="white" />
    </svg>
  </div>
);

export const BrandLockup = ({ clinicName, compact = false }) => (
  <div className="flex items-center gap-3 min-w-0">
    <BrandTile className={compact ? 'h-9 w-9' : 'h-10 w-10'} iconClass={compact ? 'h-4.5 w-4.5' : 'h-5 w-5'} />
    <div className="min-w-0 leading-tight">
      <div className="flex items-baseline gap-1">
        <span className="font-display text-[17px] font-extrabold tracking-tight text-foreground">
          Dentu
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-brand-to" />
      </div>
      <p className="truncate text-[11px] font-medium text-muted-foreground">
        {clinicName || 'Gestión clínica'}
      </p>
    </div>
  </div>
);
